const ERROR_TEXT = "<ERR:NO_KEY>";

export function getLocaleWiseLabel(pageLabels = [], labelKey, locale) {
  pageLabels = typeof pageLabels !== "undefined" ? pageLabels : [];
  var index = pageLabels.findIndex((obj) => obj.labelKey == labelKey);
  if (index == -1) return ERROR_TEXT;
  var localeTxt = pageLabels[index].labelValue[locale];
  return localeTxt ? localeTxt : ERROR_TEXT;
}
